import { Routes, RouterModule } from '@angular/router';
import { CheckSessionGuard } from '../../shared/services/guards/session.guards';
import { FlightScheduleComponent } from './flight-schedule.component';
import { CreateComponent } from './create/create.component';
import { ListComponent } from './list/list.component';
import { ListPassengersComponent } from './list-passengers/list-passengers.component';

const appRoutes: Routes = [
  {
    path: 'flight-schedule',
    component: FlightScheduleComponent,
    children: [
      {
        path: 'list',
        component: ListComponent,
        canActivate: [ CheckSessionGuard ]
      },
      {
        path: 'create',
        component: CreateComponent,
        canActivate: [ CheckSessionGuard ]
      },
      {
        path: 'modify/:id',
        component: CreateComponent,
        canActivate: [ CheckSessionGuard ]
      },
      {
        path: 'passengers/:id',
        component: ListPassengersComponent,
        canActivate: [ CheckSessionGuard ]
      },
      {
        path: '',
        redirectTo: '/flight-schedule/list',
        pathMatch: 'full'
    },
    ]
  }
];

export const APP_ROUTES_MAIN = RouterModule.forChild(appRoutes);
